var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigRotateleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 34 34",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.3875 28.0875-1.6125-1.6125 3-3.0375c-3.4-.375-6.2125-1.2-8.4375-2.475s-3.3375-2.8875-3.3375-4.8375c0-1.975 1.45625-3.65625 4.36875-5.04375s6.45625-2.08125 10.63125-2.08125c4.2 0 7.75.69375 10.65 2.08125s4.35 3.06875 4.35 5.04375c0 1.475-.8 2.775-2.4 3.9s-3.725 2-6.375 2.625v-2.4375c2-.5 3.5875-1.15 4.7625-1.95s1.7625-1.5125 1.7625-2.1375c0-.8-1.04375-1.8125-3.13125-3.0375s-5.29375-1.8375-9.61875-1.8375c-4.3 0-7.5.6125-9.6 1.8375s-3.15 2.2375-3.15 3.0375c0 1.125.71875 2.09375 2.15625 2.90625s3.93125 1.55625 7.48125 2.23125l-3.1125-3.0375 1.6125-1.6125 5.7375 5.7z",
    fill: "#555",
    transform: "matrix(-1 0 0 1 34 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigRotateleft);
export default __webpack_public_path__ + "static/media/big_rotateleft.cee28d2ba00d138c9d1969d9031385a0.svg";
export { ForwardRef as ReactComponent };